import React, { useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: 'What pre-built workflows do you already support?',
  answer: 'We have a few pre-built workflows for UHC Small Group, Kaiser, Aetna, Cigna, and several other major carriers — plus Employee Navigator setup and maintenance. These are ready to go on day one.'
}, {
  question: 'Can you take on workflows beyond your pre-built ones?',
  answer: 'Absolutely. Just walk us through your process once, and we can have a new workflow up and running in under 24 hours. We adapt to how your team already works.'
}, {
  question: 'How do you learn our specific workflows?',
  answer: 'We make it incredibly simple. You just share a quick screen recording of how your team currently handles a task (like a group install or quoting process). Our AI analyzes the recording to build the automation, and our expert team reviews it to ensure perfect accuracy before it goes live.'
}, {
  question: 'What systems and portals do you work with?',
  answer: 'We work across all major carrier portals, Employee Navigator, and other ben admin platforms your brokerage uses. We operate within the access and permissions you define.'
}, {
  question: 'How does pricing work?',
  answer: 'We price per task we complete. Our pricing is competitive because we deliver the same work faster, more reliably, and at lower cost than in-house or outsourced teams.'
}];
function FAQItemComponent({
  item,
  index
}: {
  item: FAQItem;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay: index * 0.05
  }} className="border-b border-gray-200 last:border-b-0" data-id="element-76">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between py-6 text-left cursor-pointer group" data-id="element-77">
        <span className="text-lg md:text-xl font-heading font-semibold text-slate-900 pr-8 group-hover:text-steel-700 transition-colors" data-id="element-78">
          {item.question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="shrink-0" data-id="element-79">
          <ChevronDownIcon className="w-5 h-5 text-slate-400" data-id="element-80" />
        </motion.div>
      </button>

      <AnimatePresence initial={false} data-id="element-81">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-82">
            <p className="pb-6 text-base md:text-lg text-slate-900/70 leading-relaxed pr-12" data-id="element-83">
              {item.answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQSection() {
  return <section className="py-24 md:py-32 bg-gray-100" data-id="element-84">
      <div className="max-w-3xl mx-auto px-6" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-12 md:mb-16 text-center" data-id="element-86">
          <span className="text-steel-700 font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-87">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-slate-900 leading-tight" data-id="element-88">
            Common questions
          </h2>
        </motion.div>

        <div className="divide-y divide-gray-200 border-t border-gray-200" data-id="element-89">
          {faqs.map((faq, index) => <FAQItemComponent key={index} item={faq} index={index} data-id="element-90" />)}
        </div>
      </div>
    </section>;
}